actions: Actions
allow: Allow
archive: Archive
back: Back
block: Block
cancel: 'Cancel'
clear: Clear
clone: Clone
close: 'Close'
confirm: Confirm
copiedValue: 'Copied "{{ value }}"'
copy: Copy
copyValue: 'Copy "{{ value }}"'
create: 'Create'
createNamed: Create {{ name }}
dateRange: Date Range
delete: 'Delete'
deleteNamed: 'Delete {{ name }}'
deleteNotification: '{{ name }} was deleted'
edit: 'Edit'
editNamed: 'Edit {{ name }}'
faqs: FAQs
filters: Filters
hide: Hide
iUnderstand: I understand
loading: Loading...
manage: Manage
menu: 'Menu'
more: More
moreInfo: 'More info'
next: Next
noChangesToSave: 'No changes to save'
none: None
ok: 'OK'
open: Open
overview: Overview
preview: Preview
price: Price
publish: Publish
refresh: Refresh
remove: Remove
removeNamed: Remove {{ name }}
removeNotification: '{{ name }} was removed'
review: Review
save: 'Save'
saved: 'Saved'
savedNamed: '{{ name }} saved'
search: Search
send: Send
share: Share
show: Show
showMore: Show More...
sort: Sort
submit: Submit
termsAndConditions: Terms & Conditions
unblock: Unblock
undo: Undo
upload: Upload
view: View

move:
  left: Move Left
  right: Move Right
  up: Move Up
  down: Move Down

zoom:
  in: Zoom In
  out: Zoom Out

deletePermanently: 'This will permanently delete <strong>{{ name }}</strong>.'
removePermanently: 'This will permanently remove <strong>{{ name }}</strong>.'
noUndo: There is no undo for this operation.
deleteConfirmation: 'Confirm deletion of <strong>{{ name }}</strong>'
removeConfirmation: 'Confirm removal of <strong>{{ name }}</strong>'

expiresOn: Expires on {{ date }}
charterIndexOnline: 'Charter Index Online'

company: 'Company'
user: 'User'

clearSearch: 'Clear Search'
noSearchResults: 'No results for "<strong>{{ query }}</strong>"'

wordCount_one: <strong>{{ count }}</strong> word
wordCount_other: <strong>{{ count }}</strong> words

measurement:
  metric:
    short: Metric
    long: Metric (Kilometers / Litres)
    meters: Meters
  imperial:
    short: Imperial
    long: Imperial (Nautical miles / US gallons) 
    feet: Feet
  meters: '{{ count }}m'
  metersLong_one: '{{ count }} meter'
  metersLong_other: '{{ count }} meters'
  feet: '{{ count }}ft'
  feetLong: '{{ count }} feet'
  kilometers: '{{ count }}km'
  kilometersLong_one: '{{ count }} kilometer'
  kilometersLong_other: '{{ count }} kilometers'
  nauticalMiles: '{{ count }}nm'
  nauticalMilesLong_one: '{{ count }} nautical mile'
  nauticalMilesLong_other: '{{ count }} nautical miles'

seasonYear:
  summer: Summer {{ year }}
  winter: Winter {{ year }}

notProvided: (not provided)

embark: Embark
disembark: Disembark
destination: Destination
yacht: Yacht

dates:
  start: Start Date
  end: End Date

boolean:
  true: Yes
  false: No
